
import {urlConfig} from '@/api/urlConfig'
import {getken} from '@/api/getToken'
import {getUrlParam} from '@/utils/urlUtil'
import {fetch} from '@/api/dataHandling'
import TransferDom from 'vux/src/directives/transfer-dom/index.js'
import Loading from 'vux/src/components/loading/index.vue'


export default {
directives: {
TransferDom
},
components: {Loading},
data () {
return {
loadingShow: false,
hcgInfo: {}
}
},
methods: {
getHcgInfo: function () {
getken()
const ivfCmrsId = getUrlParam('ivfCmrsId')
fetch('post', urlConfig.queryFetByCmrsId + '?ivfCmrsId=' + ivfCmrsId).then(resp => {
this.hcgInfo = resp
this.loadingShow = false
}).catch(() => {
this.loadingShow = true
})
}
},
created () {
this.loadingShow = true
this.getHcgInfo() 
}
}



// WEBPACK FOOTER //
// ./src/project/vipMsg/vipFetMsg.vue